import { Result, DeleteData } from 'domain/types';
import DeactivateAutomationClient from 'use-case/automation/deactivate/deactivateAutomationClient';
import DeactivateAutomationCriteria from 'use-case/automation/deactivate/deactivateAutomationCriteria';

export type DeactivateAutomationResult = Result<DeleteData>;
export type DeactivateAutomation = (criteria: DeactivateAutomationCriteria) => Promise<DeactivateAutomationResult>;

export default (deactivateAutomationClient: DeactivateAutomationClient): DeactivateAutomation => (
    criteria: DeactivateAutomationCriteria
): Promise<DeactivateAutomationResult> => deactivateAutomationClient(criteria);
